export default __webpack_public_path__ + "static/media/Quiken_Mejores_tarifas_envio-14.07bcf9b8.svg";